// @flow
import { makeApiCall } from "../apiService/apiService";
import { getCookie } from "../helpers";
import config from "../../configs/envConfig";

export const authActions = {
  SET_USER_PROFILE: "GET_USER_PROFILE",
  TO_BE_DELETED: "TO_BE_DELETED"
};

export const toBeDeletedTestActionCreator = (text: string) => ({
  type: authActions.TO_BE_DELETED,
  payload: text
});

export const setUserProfile = (data: Object) => ({
  type: authActions.SET_USER_PROFILE,
  payload: data
});

export const getUserProfile = () => (dispatch: Function) => {
  // const qaApi = "https://zoom-api-qa.stg.rivigo.com";
  const encodedCurrentUrl = encodeURIComponent(window.location.href);
  const sessionUserCallObj = {
    method: "POST",
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "sessionUser",
    successCb: res => {
      dispatch(setUserProfile(res.response));
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log("Getting session user failed ", res);
      window.location.href = `${config.loginUrl}&redirect_url=${encodedCurrentUrl}`;
      // Think about the above step
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log("Exception while fetching user profile, err= ", res);
      window.location.href = `${config.loginUrl}&redirect_url=${encodedCurrentUrl}`;
    }
  };
  return makeApiCall(sessionUserCallObj);
};

// eslint-disable-next-line
export const logout = () => (dispatch: Function) => {
  const logoutCallObj = {
    method: "DELETE",
    baseUrl: "logoutUrl",
    apiEndPoint: "logout",
    pathVariables: [{ key: "authToken", val: getCookie("access_token") }],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log("Successfully logged out ", res);
      window.location.href = config.loginUrl;
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log("Failure in logging out ", res);
      window.location.href = config.loginUrl;
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log("Exception while logging out, err= ", res);
      window.location.href = config.loginUrl;
    }
  };
  return makeApiCall(logoutCallObj);
};



// WEBPACK FOOTER //
// ./app/services/authService/authActionCreator.js